<div class="sidebar-header">
    <div class="logo-container d-flex align-items-center">
        <div class="logo-container w-100 d-flex align-items-center">
            <a [routerLink]="['overview']" [title]="title" class="logo logo-big">
                <span [inlineSVG]="logoPath" [cacheSVG]="true" [ngClass]="isMEDProjectEnabled ? 'ms-0' : 'ms-4'"></span>
            </a>
        </div>
    </div>
    <div class="user-container-opened-nav d-flex align-items-center" *ngIf="isNavbarOpen && isLoggedIn">
        <div
            *ngIf="userInfo?.sub"
            class="user-info-wrapper position-relative h-100 w-100"
            routerLinkActive="active"
            [routerLink]="'/user/profile/' + userInfo?.sub"
            [ngbTooltip]="'MY_WORKSPACE.USER_PROFILE.PROFILE_TOOLTIP' | translate"
            placement="bottom-right"
        >
            <div class="d-flex flex-grow-1 align-items-center ps-4 user-info position-absolute">
                <ca-avatar [avatarModel]="avatarModel" data-uit="sidebar-avatar"></ca-avatar>
                <div class="user-caption overflow-hidden py-2 font-m" *ngIf="userInfo" data-uit="sidebar-user-name">
                    {{ userInfo | fullName }}
                </div>
            </div>
        </div>
        <div class="mb-1 submenu">
            <ca-dropdown-submenu data-uit="user-submenu" className="sidebar-nav-dropdown">
                <button type="button" class="dropdown-item" routerLinkActive="active" [routerLink]="'/user/profile/' + userInfo?.sub">
                    {{ 'MENU.PROFILE' | translate }}
                </button>
                <button type="button" class="dropdown-item" routerLinkActive="active" routerLink="/admin" *ngIf="userInfo?.isAdmin">
                    {{ 'MENU.ADMINISTRATION' | translate }}
                </button>
                <button *ngIf="!isMEDProjectEnabled" type="button" class="dropdown-item" routerLinkActive="active" routerLink="/user/client-keys">
                    {{ 'MENU.MY_ACCESS_TOKENS' | translate }}
                </button>
                <button type="button" class="dropdown-item" routerLinkActive="active" routerLink="/experimental-features" *ngIf="userInfo?.isAdmin">
                    {{ 'MENU.EXPERIMENTAL_FEATURES' | translate }}
                </button>
                <button type="button" class="dropdown-item" routerLinkActive="active" routerLink="/component-showcase" *ngIf="shouldComponentShowcaseBeShown">
                    {{ 'MENU.COMPONENT_SHOWCASE' | translate }}
                </button>
                <button type="button" data-uit="logout-button" class="dropdown-item" (click)="logout()">{{ 'GENERAL.LOGOUT' | translate }}</button>
            </ca-dropdown-submenu>
        </div>
    </div>
</div>
